const theme = {
    fonts: {
        main: "var(--font-sans)",
        display: "var(--font-serif)",
        code: "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace",
        primary: "var(--font-serif)",
    },
    colors: {
        black: "var(--fg)",
        white: "var(--elevated)",
        greyLight1: "var(--bg)",
        greyLight2: "var(--muted)",
        greyDark: "var(--muted)",
        grey5: "var(--muted)",
        grey9: "var(--elevated)",
        blue: "var(--accent)",
        orange: "var(--accent)",
        red: "var(--accent)",
        primary5: "var(--accent)",
        transparent: "transparent",
        bg: "var(--bg)",
        elevated: "var(--elevated)",
        fg: "var(--fg)",
        muted: "var(--muted)",
        accent: "var(--accent)",
        border: "var(--border)",
    },
    breakpoints: {
        desktop: "only screen and (min-width: 64rem)",
        tablet: "only screen and (min-width: 48rem)",
    },
    spacings: {
        xxxSmall: ".1rem",
        xxSmall: ".4rem",
        xSmall: ".97rem",
        small: "1.6rem",
        medium: "3.3rem",
        large: "4.8rem",
        xLarge: "6.4rem",
        xxLarge: "9.6rem",
    },
    sizes: {
        xxxSmall: ".4rem",
        xxSmall: ".8rem",
        xSmall: "1rem",
        small: "1.6rem",
        medium: "3.3rem",
        large: "4.8rem",
        xLarge: "6.4rem",
        xxLarge: "9.6rem",
        default: "3.2rem"
    },
    weights: {
        normal: "normal",
        bold: "bold",
        bolder: "bolder",
        large: "400",
        xLarge: "700",
        xxLarge: "900",
    },
    heights: {
        small: "0.8rem",
        normal: "1.5rem",
        large: "2.7rem",
        xLarge: "4rem",
        xxLarge: "4.8rem",
    },
    animations: {
        button: "border-color 0.2s ease, color 0.2s ease, background 0.2s ease",
        link: "color 0.2s ease",
    },
    shadows: {
        shadow1: "none",
    },
    radius: {
        small: "var(--radius-sm)",
        medium: "var(--radius-md)",
        large: "var(--radius-lg)",
    },
    decoration: {
        italic: "italic"
    }
};

export default theme;
